import { faAdd, faCalendar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import PageLayout from "../components/page-layout";
import Charts from "../components/charts";
import TopBarWidget from "../components/top-dashboard-widget";
import DateRangePicker from "../components/date-range-picker";
import { useRangePicker } from "../store/use-range-picker-model";
import UseGraph from "../utils/use-graph";

export default function Dashboard() {
  const { onToggleRangePicker } = useRangePicker();
  const { setDates, startDate, endDate } = UseGraph();
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/createChase");
  };

  const rangeLabel = !startDate
    ? "All time"
    : `${moment(startDate).format("D MMM")}${
        endDate ? ` – ${moment(endDate).format("D MMM")}` : ""
      }`;

  return (
    <PageLayout
      pageTitle="Dashboard"
      primaryAction={
        <button
          onClick={handleClick}
          disabled
          title="Creating chases is currently disabled"
          className="flex gap-2 text-[15px] font-dmSans font-[600] items-center h-10 px-5 text-white bg-gradient-to-r from-accent to-accent-bright rounded-full shadow-[0_8px_20px_-8px_rgba(99,102,241,0.65)] transition-all duration-200 disabled:opacity-40 disabled:shadow-none disabled:cursor-not-allowed disabled:hover:translate-y-0 enabled:hover:shadow-[0_10px_24px_-8px_rgba(99,102,241,0.8)] enabled:hover:-translate-y-px"
        >
          <FontAwesomeIcon icon={faAdd} />
          New Chase
        </button>
      }
    >
      <div className="flex items-center gap-2">
        <DateRangePicker onChange={setDates}>
          <div
            className="flex items-center gap-2.5 h-10 px-4 rounded-full text-[14px] font-medium bg-surface text-text-secondary border border-edge shadow-card hover:border-edge-strong hover:text-text-primary transition-colors duration-200 outline-none cursor-pointer"
            onClick={onToggleRangePicker}
          >
            <FontAwesomeIcon icon={faCalendar} className="text-light-gray" />
            {rangeLabel}
          </div>
        </DateRangePicker>
      </div>

      <TopBarWidget />
      <Charts />
    </PageLayout>
  );
}
